import PageImage from './PageImage';

interface IProps {
  src: string;
  pictureClassName?: string;
  bgScaleClassName?: string;
  bgClassName?: string;
  isBgCenter?: boolean;
  isLazy?: boolean;
}

export default function ContentBg({
  src,
  isBgCenter,
  pictureClassName,
  bgScaleClassName = 'scale-[1.35]',
  bgClassName,
  isLazy,
}: IProps) {
  return (
    <PageImage
      src={src}
      pictureClassName={cn(
        'left-0 top-0',
        'w-full h-full overflow-hidden !absolute -z-1',
        pictureClassName
      )}
      className={cn(
        'w-full object-cover',
        isBgCenter ? 'origin-center' : 'origin-top',
        bgScaleClassName,
        bgClassName
      )}
      alt=""
      isLazy={isLazy}
    />
  );
}
